import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['symbolInput', 'categorySelect', 'validationResult'];

  validateSymbol() {
    const unit = this.symbolInputTarget.value.trim();
    if (!unit) {
      this.showValidation('Enter a unit symbol first.', 'gray');
      return;
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    const category = this.hasCategorySelectTarget ? this.categorySelectTarget.value.trim() : '';

    fetch('/units/validate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      body: JSON.stringify({ unit: unit, category: category })
    })
      .then(response => response.json())
      .then(data => {
        if (!data.valid) {
          this.showValidation(`Invalid: ${data.error}`, 'red');
          return;
        }

        if (data.category_status === 'compatible') {
          this.showValidation(
            `Valid unit: ${data.formatted_html} — compatible with "${data.category}" (checked against ${data.reference}).`,
            'green',
            true
          );
        } else if (data.category_status === 'no_reference') {
          this.showValidation(
            `Valid unit: ${data.formatted_html} — no other units in "${data.category}" yet, so nothing to check against.`,
            'green',
            true
          );
        } else {
          this.showValidation(`Valid unit: ${data.formatted_html}`, 'green', true);
        }
      })
      .catch(() => {
        this.showValidation('Unable to validate unit.', 'red');
      });
  }

  showValidation(message, color, html = false) {
    const el = this.validationResultTarget;
    if (html) {
      el.innerHTML = message;
    } else {
      el.textContent = message;
    }
    el.className = `mt-2 ml-1 text-sm text-${color}-600`;
    el.classList.remove('hidden');
  }
}
